import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ScientificArchiveFolderComponent } from "./scientific-archive-folder.component";
import { TabletViewTabsModule } from "../shared/components/tablet-view-tabs/tablet-view-tabs.module";
import { SkeletonDocumentModule } from "../shared/components/skeleton-document/skeleton-document.module";
import { ButtonModule } from "primeng/button";
import { MessagesModule } from "primeng/messages";
import { ScientificArchiveMapModule } from "../shared/components/scientific-archive-map/scientific-archive-map.module";
import { ScientificArchiveFolderDetailsComponent } from "./scientific-archive-folder-details/scientific-archive-folder-details.component";
import { CardScrollerModule } from "../shared/components/card-scroller/card-scroller.module";
import { AccordionPanelModule } from "../shared/components/accordion-panel/accordion-panel.module";
import { TranslateModule } from '@ngx-translate/core';
import { ArcGisMapComponent } from "../arcgis-map/arcgis-map.component";
import { ReturnFocusDirective } from "../shared/directives/return-focus.directive";

@NgModule({
    imports: [
    CommonModule,
    TabletViewTabsModule,
    SkeletonDocumentModule,
    ButtonModule,
    MessagesModule,
    ScientificArchiveMapModule,
    CardScrollerModule,
    AccordionPanelModule,
    TranslateModule,
    ArcGisMapComponent,
    ReturnFocusDirective
],
    declarations: [
        ScientificArchiveFolderComponent,
        ScientificArchiveFolderDetailsComponent
    ],
    exports: [
        ScientificArchiveFolderComponent
    ]
})
export class ScientificArchiveFolderModule { }